import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const DEFAULT_CONTENT = {
  hero: {
    badge: "Jetzt im Google Play Store",
    heading_line1: "Was sollen wir",
    heading_line2: "heute kochen?",
    subheading:
      "Mit Waskowi gehört das Grübeln in der Küche der Vergangenheit an! Egal, ob Sie Ihre eigenen Lieblingsgerichte verwalten, neue Inspirationen suchen oder sich von künstlicher Intelligenz (KI) überraschen lassen wollen – Waskowi ist Ihr smarter Koch- und Einkaufsbegleiter für jeden Tag.",
    cta_button: "Im Google Play Store laden",
    image_url:
      "https://images.pexels.com/photos/13716613/pexels-photo-13716613.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    image_alt: "Frisches Gemüse auf einer Küchenarbeitsplatte",
  },
  download_link: "https://play.google.com/store/apps/details?id=app.emergent.recipe2lista863a385",
  features_heading: "Alles für Ihre Küche – in einer App",
  features_subheading:
    "Von der Rezeptidee bis zum fertigen Einkauf: Waskowi begleitet Sie durch jeden Schritt in der Küche.",
  sections: [
    {
      title: "Rezepte sammeln & mit KI erstellen",
      items: [
        { lead: "Ihre private Rezeptsammlung", text: "Speichern Sie all Ihre Lieblingsgerichte an einem sicheren, privaten Ort." },
        { lead: "Smarter KI-Import", text: "Scannen Sie Rezepte aus Ihren Kochbüchern per KI ein oder importieren Sie Online-Gerichte blitzschnell über einen Link." },
        { lead: "KI-Rezeptgenerator", text: "Lassen Sie sich von unserer KI Rezepte für bestimmte Gerichte vorschlagen oder generieren Sie automatisch 10 maßgeschneiderte Rezepte nach Ihren Vorlieben." },
        { lead: "Öffentlicher Bereich", text: "Entdecken Sie hunderte Rezepte der Community oder teilen Sie Ihre eigenen Kreationen sicher und urheberrechtskonform mit der Welt." },
        { lead: "Volle Flexibilität", text: "Passen Sie jedes Rezept in Ihrem privaten Bereich jederzeit völlig flexibel an und verändern Sie es nach Ihrem Geschmack." },
      ],
    },
    {
      title: "Kochen leicht gemacht",
      items: [
        { lead: "Automatische Portionierung", text: "Ändern Sie die Portionsanzahl – die Zutatenmengen passen sich völlig automatisch an." },
        { lead: "Nährwerte im Blick", text: "Für jedes Rezept werden die Nährwerte automatisch für Sie berechnet." },
        { lead: "Ihr persönlicher Koch-Bot", text: "Fragen beim Kochen? Unser digitaler Küchenchef beantwortet Ihnen alle Fragen rund um die Zubereitung." },
        { lead: "Ihr eigenes Kochbuch", text: "Drucken Sie Ihre private Rezeptsammlung als echtes, physisches Kochbuch aus." },
        { lead: "Mit Freunden teilen", text: "Senden Sie Ihre Lieblingsrezepte ganz einfach via WhatsApp und Co. an Familie und Freunde." },
      ],
    },
    {
      title: "Der perfekte Einkaufsplaner",
      items: [
        { lead: "Smarte Einkaufsliste", text: "Wählen Sie Ihre Rezepte aus – Waskowi fasst identische Zutaten automatisch zu einer einzigen Position zusammen." },
        { lead: "Supermarkt-Sortierung", text: "Die Liste wird automatisch nach Produktgruppen sortiert, damit Sie schneller durchs Geschäft gehen." },
        { lead: "Flexibel & Offline", text: "Ergänzen Sie eigene Notizen (wie Spülmittel), bearbeiten Sie alles manuell und nutzen Sie die Liste dank Offline-Modus auch im Funkloch." },
        { lead: "Einfach abhaken", text: "Haken Sie erledigte Zutaten direkt im Einkaufswagen ab." },
      ],
    },
  ],
  perks_heading: "Weitere Vorteile von Waskowi",
  perks: [
    { icon: "Globe", title: "Zweisprachig", text: "Nutzen Sie die App wahlweise auf Deutsch oder Englisch." },
    { icon: "MessageCircle", title: "Direkter Draht", text: "Senden Sie Feedback oder Wünsche direkt aus der App an den Admin." },
  ],
  final_cta_heading: "Schluss mit der ewigen Suche nach dem nächsten Essen.",
  final_cta_subheading:
    "Laden Sie Waskowi jetzt herunter und bringen Sie neuen Schwung in Ihre Küche!",
  final_cta_button: "Im Google Play Store laden",
  footer_tagline:
    "Waskowi – Ihr smarter Koch- und Einkaufsbegleiter für jeden Tag.",
  contact_email: "christianberres1@gmail.com",
  impressum: {
    name: "",
    street: "",
    postal_city: "",
    country: "Deutschland",
    phone: "",
    email: "",
    ust_id: "",
    responsible_name: "",
    responsible_street: "",
    responsible_postal_city: "",
  },
};

export function useSiteContent() {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/content`)
      .then((r) => {
        if (mounted && r.data) {
          setContent({
            ...DEFAULT_CONTENT,
            ...r.data,
            impressum: { ...DEFAULT_CONTENT.impressum, ...(r.data.impressum || {}) },
          });
        }
      })
      .catch(() => {
        /* fall back to defaults */
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return { content, loading };
}
